import { EntityList } from '@avangard/utils/entity';
import { LessonsInstructorEntity } from './lessons-instructor-entity';

import type { Entity } from './lessons-instructor-entity';

class LessonsInstructorEntityList extends EntityList<LessonsInstructorEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(LessonsInstructorEntity, items, count);
    }
}

export { LessonsInstructorEntityList };
